// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SalonButtonWrapper_wrapper__T2p0R","center":"SalonButtonWrapper_center__UKAOx"};